import React from "react";

interface BandwidthUsageProps {
  title: string;
  usagePercentage: number;
  downloadSpeed: string;
  uploadSpeed: string;
}

const BandwidthUsage: React.FC<BandwidthUsageProps> = ({
  title,
  usagePercentage,
  downloadSpeed,
  uploadSpeed,
}) => {
  return (
    <div className="widget bandwidth-usage">
      <div className="widget-header">
        <h3>{title}</h3>
      </div>
      <div className="widget-body">
        <div className="usage-gauge">
          <div
            className="gauge-fill"
            style={{ width: `${usagePercentage}%` }}
          ></div>
          <span className="usage-percentage">{usagePercentage}%</span>
        </div>
        <div className="bandwidth-stats">
          <div className="stat-row">
            <span>Download</span>
            <span className="stat-value">{downloadSpeed}</span>
          </div>
          <div className="stat-row">
            <span>Upload</span>
            <span className="stat-value">{uploadSpeed}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export { BandwidthUsage };